import { useState } from 'react'
import InventoryIndicator from './InventoryIndicator'
import InventoryLocationsModal from './InventoryLocationsModal'

/**
 * How much of this item is on hand, and where. Owns the locations modal it
 * opens, so the process view neither knows the modal exists nor holds its state.
 *
 * `result` is the item detail's declared `query`, already reduced, which is what
 * keeps the endpoint in config rather than here.
 */
const InventoryStock = ({ block, line, result, itemId, itemName }) => {
    const [open, setOpen] = useState(false)

    return (
        <div style={{ marginTop: '0.75rem' }}>
            <InventoryIndicator
                itemId={itemId}
                totalQty={result?.total ?? 0}
                locationCount={result?.count ?? 0}
                label={block.label}
                buttonLabel={block.buttonLabel}
                icon={block.icon}
                onOpenModal={() => setOpen(true)}
            />
            {open && (
                <InventoryLocationsModal
                    itemId={itemId}
                    itemName={itemName}
                    currentLocationId={line?.[block.currentLocationField ?? 'fromLocationId']}
                    onClose={() => setOpen(false)}
                />
            )}
        </div>
    )
}

export default InventoryStock
